// 上账单
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div>
          <vxe-grid show-overflow  :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
          >

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog">新增
                  </vxe-button>
                  <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog">批量导入
                  </vxe-button>
                  <vxe-button status="primary" class="button-sty" icon="el-icon-top"
                              @click="openEditDialog">批量导出
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <el-input placeholder="请输入上帐单号" style="width: 200px;     height: 27px !important;"
                            v-model="formData.fuzzySearchValue" clearable>
                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                  </el-input>
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;"
                              class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
                  <div style="display: flex;margin-top: 5px;margin-right: 5px;color: #409eff;" @click="showMoreOptions = !showMoreOptions">
                    <svg t="1682558973727" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="1587" width="16" height="16">
                      <path
                        d="M921.6 686.08h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m0-122.88h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m-166.4-289.28c-2.56 2.56-243.2 227.84-243.2 227.84v389.12l-163.84-81.92v-307.2L112.64 281.6c-2.56-2.56-5.12-5.12-7.68-5.12-15.36-15.36-23.04-35.84-23.04-58.88 0-46.08 38.4-84.48 84.48-84.48h527.36c46.08 0 84.48 38.4 84.48 84.48 0 23.04-10.24 43.52-23.04 56.32zM693.76 179.2H166.4C145.92 179.2 128 197.12 128 217.6c0 10.24 2.56 20.48 10.24 25.6l2.56 2.56 227.84 215.04 15.36 12.8 2.56 25.6-2.56 273.92 81.92 40.96V473.6l15.36-12.8 230.4-212.48 2.56-2.56c7.68-7.68 10.24-15.36 10.24-25.6 7.68-23.04-10.24-40.96-30.72-40.96z m-17.92 588.8H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48h-245.76c-10.24 0-20.48-10.24-20.48-20.48 0-12.8 7.68-20.48 20.48-20.48z"
                        fill="#0ea2f0" p-id="1588"></path>
                    </svg>
                    <span>更多筛选</span>
                  </div>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form v-show="showMoreOptions" ref="form" class="screen-box" title-width="5vw"
                          title-align="right" :data="formData" @submit="searchEvent" @reset="searchEvent">
                  <vxe-form-item title="状态:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.stat" clearable style="width:11vw ;">
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="0" label="制单"></el-option>
                        <el-option :value="1" label="申请"></el-option>
                        <el-option :value="2" label="审核"></el-option>
                        <el-option :value="3" label="已发货"></el-option>
                        <el-option :value="4" label="已收货"></el-option>
                        <el-option :value="9" label="驳回"></el-option>
                        <el-option :value="98" label="已结算"></el-option>
                        <el-option :value="99" label="取消"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="服务中心:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.orgId" size="small" style="width:11vw ;" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search"
                           @click="showPreconditionDialog = true"></i>
                      </el-input>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot>
                      <el-autocomplete
                        class="inline-input"
                        style="width:11vw ;"
                        v-model="formData.siteName"
                        :fetch-suggestions="querySiteSearch"
                        placeholder="请输入内容"
                        :trigger-on-focus="false"
                        @select="handleSiteSelect"
                      />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="申请类型:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.applyType" clearable style="width:11vw ;">
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="1" label="储备订单"></el-option>
                        <el-option :value="2" label="加急单"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="创建时间:" field="name" style="width:25%!important;">
                    <template v-slot style=" display: inline-block;width:25%!important;">
                      <el-date-picker style="width: 14vw;" v-model="formData.createDate" type="daterange" align="right"
                                      unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="发出类型:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.outType" clearable style="width: 11vw!important;">
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="1" label="总部"></el-option>
                        <el-option :value="2" label="中心"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="收货人:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.deliverMan" size="small" style="width:11vw ;" clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="收货人号码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.deliverMobile" size="small" style="width:11vw ;" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="物流单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.deliverNo" size="small" style="width:11vw ;" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="审核时间:" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 14vw;" v-model="formData.checkDate" type="daterange" align="right"
                                      unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == index,
											btnGoodsStatusBt: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <preconditionDialog v-if="showPreconditionDialog" :visiable.sync="showPreconditionDialog" multi="true"/>

    <preconditionDialog2 v-if="showPreconditionDialog2" :visiable.sync="showPreconditionDialog2" multi="true"/>
  </div>
</template>

<script>
import editView from './edit.vue';
import preconditionDialog from './dialog';
import preconditionDialog2 from './dialog2.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";

export default {
  inject: ['reload'],
  components: {editView, pager, preconditionDialog, preconditionDialog2},
  data() {
    return {
      total: 0,
      brandOptions: [],
      orderTypeOptions: [],
      serviceTypeOption: [],
      dispatchStatOptions: [],
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        stat: 1,
        orgId: null,
        siteId: null,
        applyType: null,
        createDateBegin: null,
        createDateEnd: null,
        outType: null,
        deliverMan: null,
        deliverMobile: null,
        deliverNo: null,
        checkDateBegin: null,
        checkDateEnd: null,

        fuzzySearchIsEnable: true,
        fuzzySearchValue: null,
      },

      formData: {
        stat: 1,
        orgId: null,
        siteId: null,
        applyType: null,
        createDate: null,
        outType: null,
        deliverMan: null,
        deliverMobile: null,
        deliverNo: null,
        checkDate: null,
        fuzzySearchValue: null
      },

      showMoreOptions: false,

      sitePromptList: [],

      goodsStatusList: [ //循环列表
        {name: "待审核", num: 0},
        {name: "已审核", num: 0},
        {name: "驳回", num: 0},
        {name: "作废", num: 0},
        {name: "全部", num: 0},

      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {
          width: 100,
          field: 'stat',
          fixed: 'right',
          title: '操作',
          showOverflow: true,
          slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              //单子此时状态  和 能执行的操作     已申诉-此时状态
              if (row.stat == 0) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">列表指派</el-dropdown-item>
                        <el-dropdown-item command="2">地图指派</el-dropdown-item>
                        <el-dropdown-item command="3">指派中心</el-dropdown-item>
                        <el-dropdown-item command="4">工单修改</el-dropdown-item>
                        <el-dropdown-item command="5">工单跟进</el-dropdown-item>
                        <el-dropdown-item command="6">打印工单</el-dropdown-item>
                        <el-dropdown-item command="7">关闭工单</el-dropdown-item>

                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ]
              } else if (row.stat == 1) {  //单子此时状态  和 能执行的操作    执行考核-此时状态
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand2(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">二次派工</el-dropdown-item>
                        <el-dropdown-item command="2">工单修改</el-dropdown-item>
                        <el-dropdown-item command="3">工单跟进</el-dropdown-item>
                        <el-dropdown-item command="4">配件申请</el-dropdown-item>
                        <el-dropdown-item command="5">打印工单</el-dropdown-item>
                        <el-dropdown-item command="6">重发短信</el-dropdown-item>
                        <el-dropdown-item command="7">关闭工单</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">工单跟进</el-dropdown-item>
                        <el-dropdown-item command="b">打印工单</el-dropdown-item>

                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ];
              } else if (row.stat == 3) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">工单跟进</el-dropdown-item>
                        <el-dropdown-item command="b">打印工单</el-dropdown-item>
                        <el-dropdown-item command="c">重发短信</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ];
              } else if (row.stat == 23) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">工单跟进</el-dropdown-item>
                        <el-dropdown-item command="b">打印工单</el-dropdown-item>
                        <el-dropdown-item command="c">重发短信</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ];
              } else if (row.stat == 24) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">工单跟进</el-dropdown-item>
                        <el-dropdown-item command="b">打印工单</el-dropdown-item>
                        <el-dropdown-item command="c">重发短信</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ];
              } else if (row.stat == 91) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">工单跟进</el-dropdown-item>
                        <el-dropdown-item command="b">打印工单</el-dropdown-item>
                        <el-dropdown-item command="c">重发短信</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ];
              }
            }
          }
        },
        { title: '上帐单号', field: 'applyNo', width: 180, slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.applyNo}</span>
              ]
            }
          }
        },
        { title: '上账科目', field: 'orgName', width: 100, },

        { title: '状态', field: 'stat', width: 75, slots: {
            default: ({row}) => {
              if (row.stat == 0) {
                return [
                  <div>
                    <span>制单</span>
                  </div>
                ];
              } else if (row.stat == 1) {
                return [
                  <div>
                    <span>待审核</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div>
                    <span>已审核</span>
                  </div>
                ];
              } else if (row.stat == 3) {
                return [
                  <div>
                    <span>驳回</span>
                  </div>
                ];
              } else if (row.stat == 4) {
                return [
                  <div>
                    <span>已收货</span>
                  </div>
                ];
              } else if (row.stat == 9) {
                return [
                  <div>
                    <span>驳回</span>
                  </div>
                ];
              } else if (row.stat == 98) {
                return [
                  <div>
                    <span>已结算</span>
                  </div>
                ];
              } else if (row.stat == 99) {
                return [
                  <div>
                    <span>作废</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '所属机构名称', field: 'orgName', width: 100, },
        { title: '网点名称', field: 'siteName', width: 100, },
        // { title: '发出类型', field: 'outType', width: 80, slots: {
        //     default: ({row}) => {
        //       if (row.outType == 1) {
        //         return [
        //           <div>
        //             <span>总部</span>
        //           </div>
        //         ];
        //       } else if (row.outType == 2) {
        //         return [
        //           <div>
        //             <span>中心</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // { title: '收货地址', field: 'area', width: 235, slots: {
        //     default: ({row}) => {
        //       return [<span>{row.deliverProvince}{row.deliverCity}{row.deliverCounty}{row.deliverTown}</span>]
        //     }
        //   }
        // },
        { title: '金额',field: 'applyQtyAll',width: 80, },
		// { title: '创建时间', field: 'createTime', width: 150, },
        { title: '创建人', field: 'createBy', width: 80, },
        { title: '创建时间', field: 'createTime', width: 150, },

      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },

  },
  created() {
    this.checkButton = this.permissions["checkButton"];
    console.log(this.checkButton, "this.checkButton");
  },

  mounted() {
    this.initSearchDate()
    this.loadTabOption()
  },

  methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createDate = [start, end]
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },


    // 加载tab数据
    loadTabOption() {
      this.$http({
        url: api.spPartsApplyHeader.getCountUrl,
        method: 'post',
        data: {}
      }).then(res => {
        // this.goodsStatusList = res.data.data
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比
      let s = null
      if (item.name === '待审核') {
        s = 1
      } else if (item.name === '待发货') {
        s = 2
      } else if (item.name === '待签收') {
        s = 3
      }
      this.requestParam.stat = s
      this.formData.stat = s
      this.flushed()
    },


    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.spPartsApplyHeader.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.requestParam.fuzzySearchIsEnable = !this.showMoreOptions

      let formData = this.formData

      this.requestParam.fuzzySearchValue = formData.fuzzySearchValue
      this.requestParam.stat = formData.stat
      this.requestParam.orgId = formData.orgId
      this.requestParam.siteId = formData.siteId
      this.requestParam.applyType = formData.applyType
      this.requestParam.outType = formData.outType
      this.requestParam.deliverMan = formData.deliverMan
      this.requestParam.deliverMobile = formData.deliverMobile
      this.requestParam.deliverNo = formData.deliverNo

      if (formData.createDate !== null && formData.length !== 0) {
        this.requestParam.createDateBegin = formData.createDate[0]
        this.requestParam.createDateEnd = formData.createDate[1]
      }

      if (formData.checkDate !== null && formData.checkDate.length !== 0) {
        this.requestParam.checkDateBegin = formData.checkDate[0]
        this.requestParam.checkDateEnd = formData.checkDate[1]
      }

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },




    ///////////////////////////////////////////////////////////////////////////////////////////////////


    addressClickEvent(row, id) {
      this.openEditDialog(row.id);
      console.log(row, id, "row");
    },
    // 选中的按钮

    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    // 打开考核弹窗
    handleCommand(command, b) {
      console.log(command, b, "command,b的值");
      this.$message('click on item ' + b);
      if (b == 1) {
        this.showPreconditionDialog = true;
      } else if (b == 2) {
        this.open()
      }
    },
    // 打开执行考核弹窗
    handleCommand2(command, b) {
      console.log(command, b, "command,b的值");
      this.$message('click on item ' + b);
      if (b == 1) {
        this.showPreconditionDialog2 = true;
      } else if (b == 2) {
        this.open()
      }
    },
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },


    // 新增
    openEditDialog(id) {

      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },

  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

::v-deep .vxe-grid .vxe-form .vxe-form--item.is--active:not(.is--hidden) {
  display: inline-block;
  width: 20%;
}

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
</style>
